<!-- <dashboardnav>
</dashboardnav> -->

<main class="reference_form-main">
  <div class="main_container">
    <form [formGroup]="staffForm">
      <div class="">
        <h3 class="form_name">User</h3>

        <div class="input">
          <label for="">Last Name (<span style="color: red">*</span>)</label>
          <input
            type="text"
            class="default_input reference-form"
            formControlName="LastName"
          />
        </div>

        <div class="input">
          <label for="">First Name (<span style="color: red">*</span>)</label>
          <input
            type="text"
            class="default_input reference-form"
            formControlName="FirstName"
          />
        </div>
        <div class="input">
          <label for="">Middle Name</label>
          <input
            type="text"
            class="default_input reference-form"
            formControlName="MiddleName"
          />
        </div>
        <div class="input">
          <label for="">Phone Number</label>
          <input
            type="text"
            class="default_input reference-form"
            formControlName="PhoneNo"
          />
        </div>
        <div class="input">
          <label for="">Email (<span style="color: red">*</span>)</label>
          <input
            type="text"
            class="default_input reference-form"
            formControlName="EmailAddress"
          />
        </div>

        <div class="input" *ngIf="showDateJoined">
          <label for="">Date Joined (<span style="color: red">*</span>)</label>
         

          <input
                    type="date"
                    value="{{
                      staffForm.value.dateJoined | date: 'yyyy-MM-dd'
                    }}"
                    class="default_input"
                    formControlName="dateJoined"
                  />
        </div>
        <div class="btn_holder">
          <button class="default_primary-button" (click)="onSubmit()">
            Submit
          </button>
          <button class="default_secondary-btn ml-2" (click)="onClearForm()">
            Reset
          </button>
        </div>
      </div>
    </form>
    <div class="display_table">
      <div class="head">
        <span class="item">S/N</span>
        <span class="item">First Name</span>
        <span class="item">Last Name</span>
        <span class="item">Middle Name</span>
        <span class="item">Phone No</span>
        <span class="item">Email</span>
      </div>

      <div class="scroll"></div>
      <div class="body_content">
        <div
          class="the_body"
          *ngFor="let staff of staffinfolistMain; index as i"
          style="cursor: pointer;"
          matTooltip="Click to edit"
          aria-label="Button that displays a tooltip when focused or hovered over"

          (click)="patchStaffForm(staff)"
        >
          <span class="content">{{ i + 1 }}</span>
          <span class="content">{{ staff.FirstName }}</span>
          <span class="content">{{ staff.LastName }}</span>
          <span class="content">{{ staff.MiddleName }}</span>
          <span class="content">{{ staff.PhoneNo }}</span>
          <span class="content">{{ staff.Email }}</span>
        </div>
      </div>
    </div>
  </div>
</main>

<div class="box green_box"></div>
<div class="box pink_box"></div>

<main class="main_staff-entry" style="display: none;">
  <form [formGroup]="staffForm">
    <div class="sign_in">
      <h2 class="title">New Staff</h2>
      <div class="contain">
        <div class="the_input">
          <label for="">Last Name</label>
          <input
            type="text"
            class="default_input"
            placeholder="Enter Last Name"
            formControlName="LastName"
          />
        </div>
        <div class="the_input">
          <label for="">First Name</label>
          <input
            type="text"
            class="default_input"
            placeholder="Enter First Name"
            formControlName="FirstName"
          />
        </div>
        <div class="the_input">
          <label for="">Middle Name</label>
          <input
            type="text"
            class="default_input"
            placeholder="Enter Middle Name"
            formControlName="MiddleName"
          />
        </div>
        <div class="the_input">
          <label for="">Phone Number</label>
          <input
            type="number"
            class="default_input"
            placeholder="Enter Mobile Number"
            formControlName="PhoneNo"
          />
        </div>
        <div class="the_input">
          <label for="">Email</label>
          <input
            type="email"
            class="default_input"
            placeholder="Enter email"
            formControlName="EmailAddress"
          />
        </div>
      </div>

      <div class="submit">
        <button class="default_primary-button" (click)="onSubmit()">
          Submit
        </button>
      </div>
    </div>
  </form>
</main>

<div class="box green_box"></div>
<div class="box pink_box"></div>
